'use es6';
import PropTypes from 'prop-types';
import TypedRecord from './TypedRecord';

export default TypedRecord(
  {
    startDate: PropTypes.number,
  },
  'ResolverLoading'
);
